export const MY_PLAYLISTS_TABS = ['all', 'assigned-to-me', 'created-by-me', 'saved', 'archived'];
export const MY_PLAYLISTS_SORT_MAP = {
  RELEVANCE_ASCENDING: {
    sortOrder: 'ASC'
  },
  RELEVANCE_DESCENDING: {
    sortOrder: 'DESC'
  },
  RECENTLY_ACCESSED_ASCENDING: {
    sortOrder: 'ASC',
    sortProperty: 'interactedAt'
  },
  RECENTLY_ACCESSED_DESCENDING: {
    sortOrder: 'DESC',
    sortProperty: 'interactedAt'
  }
};
export const MY_PLAYLISTS_TABS_MAP_TO_INTERACTION = {
  all: ['CREATED', 'ASSIGNED', 'SAVED'],
  saved: ['SAVED'],
  'assigned-to-me': ['ASSIGNED'],
  'created-by-me': ['CREATED'],
  archived: ['ARCHIVED']
};